import { useQuery } from '@tanstack/react-query';
import { CLIENT_ID_QUERY_KEY } from '@/consts/const';
import { useFetch } from '@/hooks/useFetch';
import { useSearchQuery } from '@/hooks/useSearchQuery';
import type { GetCardsListResponse } from '@/types/clientDetailsApiTypes';
import { CREDIT_CARDS_LIST_QUERY_KEY } from '../../consts/client-detail';

export type UseGetCreditCardsListQueryOptions = {
  clientIdOverride?: string | null;
  enabled?: boolean;
};

export const useGetCreditCardsListQuery = (options?: UseGetCreditCardsListQueryOptions) => {
  const [searchQuery] = useSearchQuery();
  const clientIdFromUrl = searchQuery.get(CLIENT_ID_QUERY_KEY);
  const clientId = options?.clientIdOverride ?? clientIdFromUrl;

  const { doFetch: getCreditCardsList } = useFetch<void, GetCardsListResponse>();

  const query = useQuery({
    queryKey: [CREDIT_CARDS_LIST_QUERY_KEY, clientId],
    queryFn: async () => {
      const data = await getCreditCardsList(`/api/clients/${clientId}/credit-cards`);
      return data;
    },
    enabled: options?.enabled !== false && !!clientId,
    gcTime: 1000,
    staleTime: 1000,
  });

  return query;
};
